import { recordJourneyEvent, type JourneyEventName } from './api';

export async function trackJourney(
  getToken: () => Promise<string | undefined>,
  eventName: JourneyEventName,
  options: { sessionId?: string; properties?: Record<string, string | number | boolean>; clientEventId?: string } = {},
) {
  try {
    await recordJourneyEvent(await getToken(), eventName, options);
  } catch {
    // Product analytics must never interrupt a practice session.
  }
}
